export default "__VITE_ASSET__DhxFIBHv__"